import React from 'react';
import { HeartIcon } from 'lucide-react';
type OrnamentProps = {
  className?: string;
  light?: boolean;
};
export function Ornament({
  className = '',
  light = false
}: OrnamentProps) {
  const line = light ? 'bg-gold-soft/60' : 'bg-gold/50';
  const icon = light ? 'fill-gold-soft text-gold-soft' : 'fill-gold text-gold';
  return <div aria-hidden="true" className={`flex items-center justify-center gap-3 ${className}`} data-id="element-173" data-mp="71mzfjfq8qtz">
      <span className={`h-px w-10 ${line}`} data-id="element-174" data-mp="325t6nsh7pnr" />
      <span className={`h-1 w-1 rotate-45 ${light ? 'bg-gold-soft' : 'bg-gold'}`} data-id="element-175" data-mp="3u6vtudohqd9b" />
      <HeartIcon className={`h-2.5 w-2.5 ${icon}`} data-id="element-176" data-mp="3u98l5hg51zz1" />
      <span className={`h-1 w-1 rotate-45 ${light ? 'bg-gold-soft' : 'bg-gold'}`} data-id="element-177" data-mp="3p8u9lpfbw7w9" />
      <span className={`h-px w-10 ${line}`} data-id="element-178" data-mp="3k9hob943v8vs" />
    </div>;
}